import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/components/common/message';
import { AppComponent } from '../../app.component';
import { ConfirmationService, DataTable, LazyLoadEvent, SelectItem } from 'primeng/primeng';
import { StorageService } from '../../services/system/storage.service';
import { MarketplaceCouponsService } from '../../services/coupon/marketplace-coupon.service';
import { ListingCoupon } from '../../models/inModels/ListingCoupon';


@Component({
  selector: 'marketplace-coupons',
  templateUrl: './marketplace-coupons.component.html',
  styleUrls: ['./marketplace-coupons.component.css']
})
export class MarketplaceCoupons implements OnInit {
  key = 'MarketplaceCoupons';
	coupons: ListingCoupon[];
	globalFilter: string;
	loading = false;
	totalRecords: number;
	filteredRecords: number;
	rowEvent:LazyLoadEvent;
	rows: SelectItem[];
	msg: Message[];
	selectedRows: number;
  createCustomCode: string;
  constructor(
    public app: AppComponent,
		private router: Router,
		private route: ActivatedRoute,
		private confirmationService: ConfirmationService,
		private couponsService: MarketplaceCouponsService,
		public storageService: StorageService
  ) { 
    this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
  }

  ngOnInit() {
  }

  
	loadLazy(event) {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;

		this.couponsService.search(event).subscribe(
			dataPager => {
				this.coupons = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.coupons = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.msg = [];
				this.msg.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

  changeRows(event) {
		this.loadLazy(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

  goBack() {
		this.router.navigate(['/']);
	}

	create() {
		this.router.navigate(['marketplace/listing-coupons/create']);
	}

	edit(coupon: ListingCoupon) {
		this.router.navigate(['marketplace/listing-coupons/edit', coupon.Code]);
	}

	confirmDelete(coupon: ListingCoupon, dt: DataTable) {
		this.confirmationService.confirm({
			message: `Do you want to delete the coupon <strong>${coupon.Code}</strong>?`,
			header: 'Delete Confirmation',
			icon: 'fa fa-trash',
			accept: () => {
				this.loading = true;
				this.couponsService.delete(coupon.Code).subscribe(
					success => {
						this.loadLazy(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.msg = [];
						this.msg.push({ severity: 'error', summary: 'Error', detail: error });
					}
				);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/marketplace-coupons/marketplace-coupons.component.ts